import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Resolver, useForm } from "react-hook-form";
import { ProductTailleSchema } from "../../../_App/Schemas/ProductTailleSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  createProductCouleurApi,
  updateProductCouleurApi,
} from "../../../_App/Redux/Slices/product_couleur/product_couleurSlice";
import { ToastSuccess } from "../../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import { ProductCouleurSchema } from "../../../_App/Schemas/ProductCouleurSchema";
import { ProductsCouleurType } from "../../../_App/Types/Entites/ProductCouleurType";

export default function ProductCouleurForm({
  ShowModal,
  setShowModal,
  ProductCouleur,
  organisation_id
}: any) {
  const dispatch = useAppDispatch();

  // init form hooks

  const formOptions = {
    resolver: yupResolver(
      ProductCouleurSchema
    ) as Resolver<ProductsCouleurType>,
  };
  const { register, handleSubmit, reset, formState } =
    useForm<ProductsCouleurType>(formOptions);
  const { errors } = formState;

  useEffect(() => {
    if (ProductCouleur) {
      reset({
        _id: ProductCouleur._id,
        organisation_id: ProductCouleur.organisation_id,
        libelle: ProductCouleur.libelle,
        code_couleur: ProductCouleur.code_couleur,
      });
    } else {
      reset({
        libelle: "",
        code_couleur: "",
      });
    }
  }, [ProductCouleur]);

  const onSubmit = async (data: any) => {
    let response;

    if (data._id) {
      response = await dispatch(updateProductCouleurApi(data));
    } else {
      data.organisation_id = organisation_id ;
      response = await dispatch(createProductCouleurApi(data));
    }

    if (response.payload.success) {
      ToastSuccess(response.payload.message);
      reset({
        libelle: "",
        code_couleur: "",
      });
      setShowModal(false);
    } else {
      ToastWarning(response.payload.message);
    }
  };

  return (
    <Modal show={ShowModal} onHide={() => setShowModal(false)}     className="modal-3"
    backdropClassName="modal-backdrop-3">
      <Modal.Header closeButton>
        <Modal.Title className="c-primary">Ajouter Couleurs</Modal.Title>
      </Modal.Header>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="form-row align-items-center justify-content-center">
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>libelle</Form.Label>
              <div className="col-auto">
                <input
                  type="text"
                  className="form-control mb-2"
                  {...register("libelle")}
                />
                <div>{errors.libelle?.message}</div>
              </div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>code_couleur</Form.Label>
              <div className="col-auto">
                <input
                  type="color"
                  className="form-control mb-2"
                  {...register("code_couleur")}
                />
                <div>{errors.code_couleur?.message}</div>
              </div>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="reset"
            onClick={(e) => setShowModal(false)}
            className="btn btn-primary-app"
          >
            Annuler
          </Button>
          <Button type="submit" className="btn btn-primary-app">
            Enregistrer
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
